import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { UserSimpleProfileDtoListGeneralResponse } from '../../data-models/identity.data.models';
import { AdminLoginReturnDtoGeneralResponse } from '../../data-models/authentication.data.models';
import { AdminRefreshTokenInputDto } from '../../data-models/userAdmin.data.models';
import { EUserType } from 'src/app/shared/shared-data-models';
import { BaseApiService } from 'src/app/shared/services/base-api.service';

@Injectable({ providedIn: 'root' })
export class UserServiceDataService {
  private controllerUrl: string = `${environment.appConfig.adminGatewayServiceBaseUrl}/api/1/User/`;
  private controllerUrl2: string = `${environment.appConfig.adminGatewayServiceBaseUrl}/api/1/AccountDashboard/`;

  constructor(private baseApiService: BaseApiService<any>) {}

  filteredUsers(
    filter: string | undefined,
    userType: EUserType | string,
    id: string | undefined
  ): Observable<UserSimpleProfileDtoListGeneralResponse> {
    return this.baseApiService.Get(
      `${this.controllerUrl}FilteredUsers?Filter=${filter}&UserType=${userType}&Id=${id}`
    );
  }

  refreshToken(
    body: AdminRefreshTokenInputDto
  ): Observable<AdminLoginReturnDtoGeneralResponse> {
    return this.baseApiService.Post(`${this.controllerUrl2}RefreshToken`, body);
  }
}
